import * as React from "react";

function SvgClose(props) {
  return <svg width={19} height={19} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M19 2.145L17.851.995 9.998 8.85 2.145.996.996 2.145 8.85 9.998.996 17.85 2.146 19l7.852-7.853L17.851 19 19 17.85l-7.853-7.852L19 2.145z" fill="currentColor" /></svg>;
}

export default SvgClose;